import { Box, Stack } from '@mui/system'
import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar'
import { Typography, Button, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Switch, Avatar, Rating, CircularProgress } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import jobImage from '../../images/jobImage.svg'
import jobLogoImage from '../../images/logoJobImage.svg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { object } from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import facebookIcon from '../../images/facebookIcon.svg'
import twitterIcon from '../../images/twitterIcon.svg'
import linkedinIcon from '../../images/linkedinIcon.svg'
import instagramIcon from '../../images/instagramIcon.svg'
import linkIcon from '../../images/linkIcon.svg'
import documentIcon from '../../images/aplicationIcon.svg'
import adImage from '../../images/adImage.png'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import JobCard from './Job/JobCard';
import ServiceCard from './Job/ServiceCard';
import profileImage from '../../images/profileImage.jpg'
import ProfileCard from '../Profile/ProfileCard';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { applyForJob, getAllSimiliarJobs, getJobById } from '../../actions/userAuth';
import Layout from '../../assets/Layout';
import { enqueueSnackbar } from 'notistack';
export default function DreamJobDetails() {
    const [showEmail, setShowEmail] = useState("");
    const [jobs, setJobs] = useState("");
    const [similiarJobs, setSimiliarJobs] = useState([]);
    const { id } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getJobById({ id }, (data) => {
            setJobs(data.data);
        }, (err) => {
            console.log(err);
        },
        ))
        dispatch(getAllSimiliarJobs(id, (data) => {
            setSimiliarJobs(data.data.data);
        }))
    }, [id]);

    const handleSwitchOneChange = () => {
        setShowEmail(!showEmail);
    };

    const navigate = useNavigate();

    const convertDate = (inputDate) => {
        if (inputDate) {
            const dateParts = inputDate.split("-");
            const year = dateParts[0];
            const month = new Date(inputDate + "T00:00:00").toLocaleString('default', { month: 'short' });
            const day = dateParts[2];

            const outputDate = `${day} ${month} ${year}`;

            return outputDate;
        }
    }

    const ConvertMongoDate = (inputDate) => {
        const date = new Date(inputDate);

        const month = date.toLocaleString('en-US', { month: 'long' }).toUpperCase();
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();

        const outputDate = `${month} ${day}, ${year}`;
        return outputDate;
    }

    const { user } = useSelector((state) => ({ ...state }));
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true);
        let payload = {
            name: user._id,
            appliedFor: id
        }
        dispatch(applyForJob(payload, (data) => {
            enqueueSnackbar("Applied for job successfully", { variant: 'success' });
            setLoading(false);
        }, (err) => {
            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
            setLoading(false);
        }));
    }

    return (
        <>
            <Layout>

                <Box mt={12} >
                    <Button
                        className='text2Mid'
                        sx={{
                            py: 1,
                            px: 3,
                            mx: {md:10, xs:1},
                            backgroundColor: '#F7FAFF',
                            borderRadius: '0.5rem',
                            color: '#2544EE',
                            border: '1px solid #2544EE',
                            '&:hover': {
                                color: '#fff',
                                backgroundColor: '#2544EE'
                            },
                        }}
                        startIcon={<ArrowBackIosIcon />}
                        onClick={() => navigate('/candidate/recommanded-jobs')}
                        variant="contained">
                        Go Back
                    </Button>
                </Box>

                <Box mx={{md:10, xs:1}} my={3}>
                    <Grid container >
                        <Grid item md={8} sx={{ maxWidth: '100%' }}>
                            <Typography
                                my={2}
                                variant="h6"
                                className='subHeading2Bold'
                            >
                                {jobs?.jobTitle}
                            </Typography>
                            <div style={{ position: 'relative' }}>
                                <img src={jobImage} alt='Job Image' width={'100%'} style={{ borderRadius: '10px' }} />
                                <IconButton
                                    style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#fff' }}
                                    color="primary"
                                    aria-label="Bookmark"
                                >
                                    <BookmarkBorderIcon sx={{ color: '#000' }} />
                                </IconButton>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        bottom: '10px',
                                        left: '10px',
                                        height: { xs: '4rem', sm: '5rem' },
                                        width: { xs: '4rem', sm: '5rem' },
                                        borderRadius: '10px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <img src={jobs?.logoUrl} alt='Job Image' width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                                </Box>
                            </div>

                            <Stack mt={2}>
                                <Typography variant="h6" className='text1Bold'>
                                    {jobs?.companyName}
                                </Typography>

                                <Typography variant="h6" className='text1Mid'>
                                    {jobs?.city} {jobs?.state} {jobs?.country}
                                </Typography>

                                <Typography variant="h6" className='text1Bold' sx={{ color: '#2544EE' }}>
                                    {jobs?.companyWebsite}
                                </Typography>

                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Job Description:
                                </Typography>
                                <Typography sx={{ textAlign: 'justify' }} variant="body2" className='text2Mid'>
                                    {jobs?.jobDescription}
                                </Typography>
                            </Stack>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Requirements
                                </Typography>
                                <List>
                                    <ListItem disablePadding mt={1}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Must be able to communicate with others to convery information effectively.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Personally passionate and up to date with current trends and technology, committied to quality and comfortable working with adult media.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Bachelor or Master degree level educational background.
                                        </Typography>
                                    </ListItem>
                                </List>
                            </Box>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Responsibilities:
                                </Typography>
                                <List>
                                    <ListItem disablePadding mt={1}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Must be able to communicate with others to convery information effectively.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Personally passionate and up to date with current trends and technology, committied to quality and comfortable working with adult media.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Bachelor or Master degree level educational background.
                                        </Typography>
                                    </ListItem>
                                </List>
                            </Box>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Additional Benefits
                                </Typography>
                                <List>
                                    {jobs?.benefitsOffered?.map((item, index) => (
                                        <ListItem disablePadding mt={1} key={index}>
                                            <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                            <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                                {item}
                                            </Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button
                                    className='text2Mid'
                                    sx={{
                                        py: 1,
                                        px: 3,
                                        backgroundColor: '#F7FAFF',
                                        borderRadius: '0.5rem',
                                        color: '#2544EE',
                                        border: '1px solid #2544EE',
                                        '&:hover': {
                                            color: '#fff',
                                            backgroundColor: '#2544EE'
                                        },
                                        '@media (max-width: 600px)': {
                                            px: 2
                                        }
                                    }}
                                    endIcon={<ArrowForwardIosOutlinedIcon />}
                                    variant="contained"
                                >
                                    Website Apply
                                </Button>

                                <Button
                                    className='text2Mid'
                                    sx={{
                                        ml: 2,
                                        py: 1,
                                        px: 3,
                                        backgroundColor: '#2544EE',
                                        borderRadius: '0.5rem',
                                        color: '#fff',
                                        border: '1px solid #2544EE',
                                        '&:hover': {
                                            color: '#2544EE',
                                            backgroundColor: '#fff'
                                        },
                                        '@media (max-width: 600px)': {
                                            px: 2
                                        }
                                    }}
                                    endIcon={<ArrowForwardIosOutlinedIcon />}
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    {
                                        loading
                                            ?
                                            <CircularProgress size={24} />
                                            :
                                            "Apply"
                                    }
                                </Button>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, my: 5 }}>
                                <Typography className='text1Bold'>Similar Jobs</Typography>
                                <Typography className='text1Bold' sx={{ color: '#2544EE' }}>View all</Typography>
                            </Box>
                            {similiarJobs.slice(0, 3).map((item, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <JobCard job={item} />
                                </Box>
                            ))}
                        </Grid>
                        <Grid item md={4} xs={12} px={{md:4, xs:1}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', justifyContent: 'space-between', }}>
                                <Typography variant="body2" className='text2Bold'>Want to Show More Similar type of Jobs?</Typography>
                                <Switch
                                    checked={showEmail}
                                    onChange={handleSwitchOneChange}
                                    style={{ color: '#2544EE' }}
                                    inputProps={{ 'aria-label': 'switch one' }}
                                />
                            </Box>
                            <Box item xs={12} md={3} px={2} py={2} sx={{ background: 'linear-gradient(to left, #F2F4FB, #C8D8F1)', borderRadius: '10px' }}>
                                <Typography
                                    variant="body"
                                    className='text1Bold'
                                >
                                    Job Information
                                </Typography>

                                <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', p: 1 }}>
                                    <CalendarTodayIcon sx={{ color: '#2544EE', mx: 1 }} />
                                    <Typography
                                        variant="caption"
                                        className='text2Mid'
                                    >
                                        Expires on {convertDate(jobs?.jobExpiryDate)}
                                    </Typography>
                                </Box>
                                <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', p: 1, my: 1 }}>
                                    <img src={documentIcon} width={'25px'} style={{ color: '#2544EE', marginLeft: '8px', marginRight: '8px' }} />
                                    <Typography
                                        variant="caption"
                                        className='text2Mid'
                                    >
                                        6 Applicant
                                    </Typography>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <CalendarMonthIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Date Posted
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {ConvertMongoDate(jobs?.createdAt)}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <BusinessIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Industry:
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    IT & Sofware
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <LocationOnIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Location
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.city}, {jobs?.state}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <FolderOpenOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Job Title
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.jobTitle}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <BusinessCenterOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Experience
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.jobExperience}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <LocalPhoneOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Phone Number
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    +91- XXXXXX9876
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <EmailOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Email Address
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    AcXXXX@gmail.com
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <AccessibilityNewOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Gender
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.genderPreference}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <SupervisedUserCircleOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    No. of Openiings
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.numberOfApplicantsHiring}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <SupervisedUserCircleOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                        </Grid>
                                        <Grid item md={1}></Grid>
                                        <Grid item md={8}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="caption" sx="font-size: 8px;">
                                                    Offered Salary
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                    {jobs?.salaryRangeFrom}-{jobs?.salaryRangeTo}/Month
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Typography variant="body1" className='text1Bold'>
                                        Social Media
                                    </Typography>
                                    <Grid container>
                                        <Grid item md={2}>
                                            <img src={facebookIcon} alt='Facebook' width={'25px'} />
                                        </Grid>
                                        <Grid item md={2}>
                                            <img src={twitterIcon} alt='Facebook' width={'25px'} />
                                        </Grid>
                                        <Grid item md={2}>
                                            <img src={linkedinIcon} alt='Facebook' width={'25px'} />
                                        </Grid>
                                        <Grid item md={2}>
                                            <img src={instagramIcon} alt='Facebook' width={'25px'} />
                                        </Grid>
                                        <Grid item md={2}>
                                            <img src={linkIcon} alt='Facebook' width={'25px'} />
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Typography variant="body1" className='text1Bold'>
                                        Skills
                                    </Typography>
                                    <Grid container>
                                        {jobs?.skills?.map((item, index) => (
                                            <Grid item md={4} my={1} key={index}>
                                                <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                                    {item}
                                                </Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                                <Box sx={{ p: 1, my: 1 }}>
                                    <Typography variant="body1" className='text1Bold'>
                                        Keywords
                                    </Typography>
                                    <Grid container>
                                        {jobs?.keywords?.map((item, index) => (
                                            <Grid item md={4} my={1} key={index}>
                                                <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                                    {item}
                                                </Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            </Box>
                            <Box
                                my={2}
                                sx={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '25rem',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(37, 68, 238, 0.5)',
                                    }}
                                />
                                <img src={adImage} alt='Image' width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                                <Box
                                    px={2}
                                    sx={{
                                        position: 'absolute',
                                        bottom: '0px',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        textAlign: 'left',
                                        color: '#FFF',
                                        width: '100%',
                                    }}
                                >
                                    <Typography variant="h3" className='heading1bold' my={1}>Recruiting?</Typography>
                                    <Typography variant="body1" my={1}>Get Best Matched jobs On your Email. Add Resume Now!</Typography>
                                    <Button
                                        variant='contained'
                                        sx={{
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                            '&:hover': {
                                                backgroundColor: '#2544EE',
                                                color: '#FFF',
                                            },
                                        }}
                                    >
                                        Read More
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, my: 5 }}>
                        <Typography className='text1Bold'>Service Available</Typography>
                        <Typography className='text1Bold' sx={{ color: '#2544EE' }}>View all</Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            <ServiceCard />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <ServiceCard />
                        </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, mt: 10 }}>
                        <Typography className='text1Bold'>Recommended Coaches</Typography>
                        <Typography className='text1Bold' sx={{ color: '#2544EE' }}>View all</Typography>
                    </Box>
                    <Grid container spacing={2} mt={4}  >
                        <Grid item md={3} xs={12} mt={{ xs: 8 }}>
                            <ProfileCard />
                        </Grid>
                        <Grid item md={3} xs={12} mt={{ xs: 8 }}>
                            <ProfileCard />
                        </Grid>
                        <Grid item md={3} xs={12} mt={{ xs: 8 }}>
                            <ProfileCard />
                        </Grid>
                        <Grid item md={3} xs={12} mt={{ xs: 8 }}>
                            <ProfileCard />
                        </Grid>
                    </Grid>

                </Box >
            </Layout>
        </>
    )
}
